/**
 * The artistic-edit mark: the CherryClipz cherry filled with a slowly turning iridescent shimmer
 * (holographic, not a flag rainbow). The cherry's own shape is the mask, so it stays our logo.
 */
import React from "react";
import cherry from "../../assets/brand/logo_site_onlight.svg";

const CSS = `
.cc-iri{display:inline-block;flex-shrink:0;-webkit-mask:url(${cherry}) center/contain no-repeat;mask:url(${cherry}) center/contain no-repeat;
background:conic-gradient(from var(--cc-iri-a,0deg),#ff5fa2,#ffb35c,#ffe66d,#5ce1a5,#5cc8ff,#8b5cf6,#e61d50,#ff5fa2);animation:ccIri 6s linear infinite}
@property --cc-iri-a{syntax:'<angle>';inherits:false;initial-value:0deg}
@keyframes ccIri{to{--cc-iri-a:360deg}}
@media (prefers-reduced-motion:reduce){.cc-iri{animation:none}}
`;

const IridescentCherry: React.FC<{ size?: number }> = ({ size = 28 }) => (
  <>
    <style>{CSS}</style>
    <span className="cc-iri" role="img" aria-label="Artistic edit" style={{ width: size * 0.625, height: size }} />
  </>
);

export default IridescentCherry;
